import { ContentBlock } from '@/types/model';
import React from 'react';
import dynamic from 'next/dynamic';
import {
  Hero,
  DisplayBlock,
  LocationBlock,
  TitleBlock,
  TextBlock,
  IconList,
  ImageDivider,
  MasterplanList,
  MasterplanBlock,
  LocationInfo,
  InterestPoint,
  AvisoPrivacidad,
  AvisoProgramaDeReferidos,
  Contact,
  IframeBlock
} from '@/components';

const Slider = dynamic(() => import('@/components/Slider'));
const ReferredList = dynamic(() => import('@/components/ReferredList'));
const CotizadorIframe = dynamic(() => import('@/components/CotizadorIframe'));
const Timeline = dynamic(() => import('@/components/Timeline'));

const getBlockComponent = ({ __typename, ...rest }: ContentBlock, index: number) => {
  let Block;

  switch (__typename) {
    case 'ComponentWebHero':
      Block = Hero;
      break;
    case 'ComponentWebDisplayBlock':
      Block = DisplayBlock;
      break;
    case 'ComponentWebLocationBlock':
      Block = LocationBlock;
      break;
    case 'ComponentWebSlider':
      Block = Slider;
      break;
    case 'ComponentWebTitleBlock':
      Block = TitleBlock;
      break;
    case 'ComponentWebTextBlock':
      Block = TextBlock;
      break;
    case 'ComponentWebIconList':
      Block = IconList;
      break;
    case 'ComponentWebImageDivider':
      Block = ImageDivider;
      break;
    case 'ComponentWebMasterplanList':
      Block = MasterplanList;
      break;
    case 'ComponentWebMasterplanBlock':
      Block = MasterplanBlock;
      break;
    case 'ComponentWebInterestPoint':
      Block = InterestPoint;
      break;
    case 'ComponentWebLocationInfo':
      Block = LocationInfo;
      break;
    case 'ComponentWebReferredList':
      Block = ReferredList;
      break;
    case 'ComponentWebCotizadorIframe':
    case 'ComponentWebCotizador':
      Block = CotizadorIframe;
      break;
    case 'ComponentWebAvisoPrivacidad':
      Block = AvisoPrivacidad;
      break;
    case 'ComponentWebAvisoProgramaDeReferidos':
      Block = AvisoProgramaDeReferidos;
      break;
    case 'ComponentWebTimeline':
      Block = Timeline;
      break;
    case 'ComponentWebContact':
      Block = Contact;
      break;
    case 'ComponentWebIframeBlock':
      Block = IframeBlock;
  }

  if (!Block) return null;

  // el switch garantiza en runtime que Block es el componente de este __typename,
  // pero TypeScript no puede seguir esa relacion entre el string y el componente
  const Componente = Block as React.ComponentType<Record<string, unknown>>;

  return <Componente key={`index-${index}`} {...rest} />;
};

const ContentManager = ({ blocks }: { blocks: ContentBlock[] }) => {
  return <>{blocks.map(getBlockComponent)}</>;
};

export default React.memo(ContentManager);
